import * as common from 'store/modules/common'
import { api } from './api'

const newEntity = {
  name: '',
  id: 0,
  canBeDeleted: true
}

export const actionTypePrefix = 'classificationByOrigins'

export { api }
export const initialState = { ...common.initialState }
export const actionTypes = { ...common.actionTypes(actionTypePrefix) }
export const actionCreators = { ...common.actionCreators(actionTypePrefix, api) }

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.create: return { ...state, entity: { ...newEntity, isDirty: true } }
    default: return common.reducer(state, action, actionTypePrefix)
  }
}

